import React from 'react';
import PropTypes from 'prop-types';
import { HeaderLocation } from '../parts/HeaderLocation';
import { ConnectedFragmentHeader } from './FragmentHeader';
import { EntryPointProp, SearchSegment } from '../../../../../models';
import { HeaderDatesSegments } from '../parts/HeaderDatesSegments';
import { HeaderPax } from '../parts/HeaderPax';
import { ConnectedFaresTrackingCalculator } from '../../../../../components/Calendar/Context/FaresTrackingCalculator';

export const FragmentHeaderRoundTrip = ({ segments, pax, activeProduct, trackType }) => {
    const hasDates = !!segments.find((segment) => !!segment.date);

    return (
        <ConnectedFaresTrackingCalculator trackType={trackType}>
            {({ extraTracking }) => (
                <ConnectedFragmentHeader extraTracking={extraTracking}>
                    <HeaderLocation segment={segments[0]} activeProduct={activeProduct} />
                    {(hasDates || !!pax) && (
                        <div className="odf-text-center">
                            <HeaderDatesSegments segments={segments} />
                            {hasDates && !!pax && ' · '}
                            <HeaderPax pax={pax} />
                        </div>
                    )}
                </ConnectedFragmentHeader>
            )}
        </ConnectedFaresTrackingCalculator>
    );
};

FragmentHeaderRoundTrip.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
    pax: PropTypes.number,
    activeProduct: EntryPointProp.isRequired,
    trackType: PropTypes.string,
};

FragmentHeaderRoundTrip.defaultProps = {
    pax: 0,
    trackType: 'close_calendar',
};
